import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { useIntl } from 'react-intl';

import { DEFAULT_LOCALE } from 'utils/i18nUtils';
import RegistrationUnavailableLanguage from 'patterns/RegistrationUnavailableLanguage/RegistrationUnavailableLanguage';
import useOpenFormVisibility from 'utils/hooks/useOpenFormVisibility/useOpenFormVisibility';
import OpenFormSection from 'patterns/OpenFormSection/OpenFormSection';

import { ResponseIcon } from '../../components/InsuranceWaitlistForm/icons/ResponseIcon';
import WaitlistForm from '../../components/InsuranceWaitlistForm/WaitlistForm';

function SectionForm({ onFormVisibilityChange, onFormAnchorPosition }) {
  const { locale } = useIntl();

  const OPTIONS = {
    intersectionOptions: {
      triggerOnce: false,
      threshold: 0.5,
    },
  };

  const [ref, isFormHidden, entry] = useOpenFormVisibility(OPTIONS);

  useEffect(() => {
    let position = false;

    if (entry) {
      position = Math.sign(entry.boundingClientRect.top);
    }
    const isAboveForm = position !== 1;

    onFormVisibilityChange(isFormHidden);
    onFormAnchorPosition(isAboveForm);
  }, [isFormHidden]);

  return (
    <Box tag="section" backgroundColor="primary.default">
      <OpenFormSection ref={ref}>
        <Grid
          row
          spacingHorizontal={{ xs: '6x', md: '12x', lg: '14x' }}
          spacingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
          justify="center"
          alignItems="center"
        >
          <Typography
            intlKey="INSURANCE.SECTION_FORM.TITLE"
            variant="title"
            color="white"
            width="100%"
            textAlign="center"
            intlValues={{ br: <br /> }}
            gutterBottom={{ xs: 1.5, md: 2, lg: 2 }}
          />
          <Box
            backgroundColor="white.default"
            padding={{ xs: '6x' }}
            borderRadius={{ xs: '1rem' }}
            display="flex"
            alignItems="center"
            maxWidth={{ lg: 380 }}
          >
            {locale === DEFAULT_LOCALE ? (
              <WaitlistForm />
            ) : (
              <>
                <ResponseIcon />
                <RegistrationUnavailableLanguage isOpenForm />
              </>
            )}
          </Box>
        </Grid>
      </OpenFormSection>
    </Box>
  );
}

SectionForm.propTypes = {
  onFormAnchorPosition: PropTypes.func.isRequired,
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default React.memo(SectionForm);
